export const isNonEmptyString = value =>
  typeof value === 'string' && value.trim().length > 0;

export const isNonEmptyArrayOrString = value =>
  (typeof value === 'string' || Array.isArray(value)) && value.length > 0;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentVisitDetails/helpers/checkFieldValues.js